import React from 'react';
import { cn } from '../../lib/utils';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  help?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}

const Input: React.FC<InputProps> = ({
  className,
  label,
  error,
  help,
  leftIcon,
  rightIcon,
  id,
  ...props
}) => {
  const inputId = id || React.useId();
  return (
    <div className={cn('w-full', className)}>
      {label && (
        <label htmlFor={inputId} className="form-label">
          {label}
        </label>
      )}
      <div className="relative">
        {leftIcon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            {leftIcon}
          </div>
        )}
        <input
          id={inputId}
          className={cn('form-input', leftIcon && 'pl-10', rightIcon && 'pr-10', error && 'border-error-500 focus:border-error-500 focus:ring-error-500')}
          {...props}
        />
        {rightIcon && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
            {rightIcon}
          </div>
        )}
      </div>
      {error ? (
        <p className="form-error">{error}</p>
      ) : help ? (
        <p className="form-help">{help}</p>
      ) : null}
    </div>
  );
};

export default Input;
